import {Box, Text, Title} from "@mantine/core";
import classes from "./SettingsBox.module.css";
type Props = {
    title: string;
    description?: string;
    children: React.ReactNode;
};

export function SettingsBox({title, description, children}: Props) {
    return (
        <Box className={classes.box}>
            <Box className={classes.header}>
                <Title order={3} className={classes.title}>
                    {title}
                </Title>
                {description && (
                    <Text size="xs" c="dimmed" className={classes.description}>
                        {description}
                    </Text>
                )}
            </Box>
            <Box className={classes.content}>{children}</Box>
        </Box>
    );
}
